"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "serravalle-a-po": {
    "877fb072": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "skipSearch": false
    }],
    "cardinala": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c197093": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "skipSearch": false
    }],
    "caselle": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd73fd20": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "skipSearch": false
    }],
    "torriana": [{
      "hkey": "57b9295e",
      "slug": "serravalle-a-po",
      "name": "Serravalle a Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;